export default class Broadcast {
    name: string;
  
    channel: BroadcastChannel;
  
    constructor(name: string) {
      if (typeof BroadcastChannel !== 'function') {
        throw Error('BroadcastChannel API is not supported!');
      }
  
      if (!name) {
        throw Error('Channel name is required to use BroadcastChannel!');
      }
  
      this.name = name;
      this.channel = new BroadcastChannel(name);
    }
  
    getName() {
      return this.name;
    }
  
    postMessage(message: string) {
      if (message) {
        this.channel.postMessage(message);
      }
    }
  
    onMessage(fn: (e: MessageEvent) => void) {
      this.channel.onmessage = fn;
    }
  
    close() {
      this.channel.close();
    }
  }
  